import { Component, OnInit, Input, Renderer2, ElementRef, NgZone } from '@angular/core';

import { throttle } from '../../helpers';
import { LayoutStore } from '../layout.store';
import { WrapperService } from './wrapper.service';
export class WrapperComponent implements OnInit {
private skin: string;
private layout: string;
private sidebarLeftElementHeight: number;
public classes: string;
/**
 * @param {?} elementRef
 * @param {?} renderer2
 * @param {?} layoutStore
 * @param {?} wrapperService
 * @param {?} ngZone
 */
constructor(
private elementRef: ElementRef,
private renderer2: Renderer2,
private layoutStore: LayoutStore,
private wrapperService: WrapperService,
private ngZone: NgZone
  ) {}
/**
 * [ngOnInit description]
 * \@method ngOnInit
 * @return {?}
 */
ngOnInit() {
    this.layoutStore.setWindowInnerHeight(window.innerHeight);
    this.layoutStore.setWindowInnerWidth(window.innerWidth);

    this.wrapperService.wrapperElementRef = this.elementRef;

    this.layoutStore.wrapperClasses.subscribe((value: string) => {
      this.classes = value ? value : null;
    });

    this.ngZone.runOutsideAngular(() => {
      this.renderer2.listen('window', 'resize', throttle(() => {
        this.layoutStore.setWindowInnerHeight(window.innerHeight);
        this.layoutStore.setWindowInnerWidth(window.innerWidth);
      }, 250));
    });

    this.layoutStore.layout.subscribe((value: string) => {
      value === 'fixed' ? this.renderer2.addClass(this.elementRef.nativeElement, 'fixed') : this.renderer2.removeClass(this.elementRef.nativeElement, 'fixed');
      value === 'boxed' ? this.renderer2.addClass(this.elementRef.nativeElement, 'layout-boxed') : this.renderer2.removeClass(this.elementRef.nativeElement, 'layout-boxed');
    });

    this.layoutStore.skin.subscribe((value: string) => {
      if(value) {
        if(this.skin && this.skin !== value){
          this.renderer2.removeClass(this.elementRef.nativeElement, `skin-${this.skin}`);
        }
        this.skin = value;
        this.renderer2.addClass(this.elementRef.nativeElement, `skin-${this.skin}`);
      }
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-layout-wrapper',
  template: `
    <div class="wrapper" [ngClass]="classes">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    :host /deep/ .sidebar-right-toggle > a {
      color: #fff;
    }

    :host /deep/ .sidebar-right-toggle > a:hover {
      background: rgba(0, 0, 0, 0.1);
    }

    :host.skin-black /deep/ .sidebar-right-toggle > a,
    :host.skin-black-light /deep/ .sidebar-right-toggle > a {
      color: #333;
      border-right-width: 0;
    }

    :host.skin-black /deep/ .sidebar-right-toggle > a:hover,
    :host.skin-black-light /deep/ .sidebar-right-toggle > a:hover {
      background-color: #fff;
      color: #999;
    }

    :host.skin-black /deep/ .sidebar-right-toggle > a {
      border-left: 1px solid #eee;
    }

    :host.skin-black-light /deep/ .sidebar-right-toggle > a {
      border-left: 1px solid #d2d6de;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: LayoutStore, },
{type: WrapperService, },
{type: NgZone, },
];
}

function WrapperComponent_tsickle_Closure_declarations() {
/** @type {?} */
WrapperComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WrapperComponent.ctorParameters;
/** @type {?} */
WrapperComponent.prototype.skin;
/** @type {?} */
WrapperComponent.prototype.layout;
/** @type {?} */
WrapperComponent.prototype.sidebarLeftElementHeight;
/** @type {?} */
WrapperComponent.prototype.classes;
/** @type {?} */
WrapperComponent.prototype.elementRef;
/** @type {?} */
WrapperComponent.prototype.renderer2;
/** @type {?} */
WrapperComponent.prototype.layoutStore;
/** @type {?} */
WrapperComponent.prototype.wrapperService;
/** @type {?} */
WrapperComponent.prototype.ngZone;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
